import { formatDate } from "../functions/formatDate";

export function handleInput(e, kind, data, setData){
    if(e && e.target){
        switch(e.target.name) {
            case "sale":
                setData( data = { ...data,
                    sale: e.target.value.replace(/[^\d.-]/g, '')
                })
                break;
            default:
                return null
        }
    }
    if(e && e._locale && kind === "begin"){
        let date = formatDate(e.format())
        data.begin = date
        /*setData( data = { ...data,
            begin: date
        })*/
    }else if(e && e._locale && kind === "end"){
        let date = formatDate(e.format())
        data.end = date
        /*setData( data = { ...data,
            end: date
        })*/
    }
}


// WEBPACK FOOTER //
// ./src/functions/handleInputs.js